<script setup>
import { reactive } from 'vue';
import { store } from '@/store';
import { hospitalDisplayOptions, hospitalValueOptions, departmentDisplayOptions, departmentValueOptions, specializationDisplayOptions, specializationValueOptions } from '@/libraries/AccountData'
import { Physician } from '@/libraries/ClassDefinitions';
import {  registerUserInformation, editUser } from '@/firebase_files/user_functions';
import router from '@/router';
import FormTextInput from './FormTextInput.vue';
import FormSelect from './FormSelect.vue';



const props = defineProps(['user']);


const newUser = reactive(new Physician());

init()
async function init() {

  if (props.user) {
    newUser.name = props.user.name;
    newUser.email = props.user.email;
    newUser.role = props.user.role;
    newUser.cpso = props.user.cpso;
    newUser.department = props.user.department;
    newUser.hospital = props.user.hospital;
    newUser.specialization = props.user.specialization;
    newUser.billingReportEmail = props.user.billingReportEmail;
  } 
}


async function submitPhysician() {
  debugger
  let result;
  if (props.user){
    result = await editUser(newUser);
  }
  else{
    store.userRole = 'physician';
    await registerUserInformation(newUser);
    store.newUser = false;
  }
  debugger
  router.push({name:'home'})
}
</script>
<template>
  <h2 class="user-title">Physician</h2>

  <FormTextInput :input="newUser.name" :promptText="'Name'" @onChange="(d) => newUser.name = d" />
  <FormTextInput :input="newUser.email" :promptText="'Email Address'" @onChange="(d) => newUser.email = d" />
  <FormTextInput :input="newUser.cpso" :promptText="'CPSO #'" @onChange="(d) => newUser.cpso = d" />
  <FormTextInput :input="newUser.billingReportEmail" :promptText="'Billing Report Email'" @onChange="(d) => newUser.billingReportEmail = d" />

  <FormSelect :input="newUser.hospital" :promptText="'Hospital'" :displayOptions="hospitalDisplayOptions"
    :valueOptions="hospitalValueOptions" @onChange="(d) => newUser.hospital = d" />
  <FormSelect :input="newUser.department" :promptText="'Department'" :displayOptions="departmentDisplayOptions"
    :valueOptions="departmentValueOptions" @onChange="(d) => newUser.department = d" />
  <FormSelect :input="newUser.specialization" :promptText="'Specialization'"
    :displayOptions="specializationDisplayOptions" :valueOptions="specializationValueOptions"
    @onChange="(d) => newUser.specialization = d" />
  <div class="submit-button">
    <button @click="submitPhysician">Submit</button>
  </div>
</template>

<style scoped lang="scss">
@import "@/styles/registration.scss"; 
</style>
